// theme.js
import { defineStyle, extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'Inter', sans-serif`,  // Tipografía para títulos
    body: `'Inter', sans-serif`,     // Tipografía para el cuerpo de texto
  },
  colors: {
    white: '#FFFFFF',
    warning: {
      200: '#F6F1E9',
      600: '#D99A41',
      800: '#A16108',
    },
    primary: {
      200: '#FFFBFA',
      500: '#FABEAD',
      800: '#F14A1D',
    },
    secondary: {
      600: '#28C7DD',
    },
    'button-primary': {
      50: '#FABEAD',
      500: '#F14A1D',
    },
    grey: {
      100: '#FAFAFA',
      600: '#7E7E7E',
      700: '#5F5F5F',
    },
    neutral: {
      100: '#F8F7F7',
      200: '#EEECED',
      300: '#D6D2D4',
      400: '#BDB7BA',
      500: '#A59CA0',
      600: '#8D8186',
      800: '#585053',
      900: '#3E383A',
      1000: '#231F20',
    },
    info: {
      800: '#3665B2',
    },
    success: {
      200: '#E7F1EC',
      400: '#ADD9C3',
      700: '#238C58',
    },
    destructive: {
      200: '#FFEBEB',
      500: '#FD6363',
      700: '#E40000',
    },
  },
  styles: {
    global: {
      // Estilos globales
      html: {
        fontSize: '75%', // Tamaño de fuente global
      },
      body: {
        bg: '#F5F5F5', // Fondo global
        color: '#585053', // Color de texto por defecto
      },
      'span': {
        color: 'primary.200', // Aplica el color primary.200 a todos los <span>
      },
      h1: {
        color: 'neutral.800',
        fontSize: 'xxl',
        fontWeight: 700,
        lineHeight: '28px',
      },
      button: {
        fontWeight: 'medium !important',
      },
      form: {
        label: {
          fontWeight: 'medium !important',
          fontSize: 'l !important',
          marginBottom: '.2em !important',
          color: 'neutral.800',
        },
        input: {
          backgroundColor: 'grey.100 !important',
          '&:disabled': {
            color: 'grey.600',
            opacity: '1 !important',
            borderColor: 'grey.100 !important',
          },
        },
      },
      table: {
        thead: {
          tr: {
            backgroundColor: 'neutral.200',
            color: 'neutral.1000',
            th: {
              textTransform: 'lowercase',
              padding: '1.5em !important',
              '&:first-of-type': {
                borderLeftRadius: 'md',
              },
              '&:last-child': {
                borderRightRadius: 'md',
              },
            },
          },
        },
        tbody: {
          tr: {
            fontSize: 'l',
            color: 'neutral.800',
            td: {
              borderColor: 'transparent !important',
              padding: '1em .5em !important',
              '&:first-of-type': {
                borderLeftRadius: 'md',
              },
              '&:last-child': {
                borderRightRadius: 'md',
              },
            },
            '&:hover': {
              backgroundColor: '#7FDEEB1A',
            },
          },
        },
      },
    },
  },
  space: {
    s: '.2em',
    l: '.5em', // 8px
    xl: '1em',
    xxl: '1.5em', // 24px
    xxxl: '2em', // 32px
  },
  borderWidths: {
    normal: '1px',
  },
  fontWeights: {
    normal: '400',
    medium: '500',
    bold: '700',
  },
  fontSizes: {
    s: '12px',
    l: '14px',
    xl: '16px',
    xxl: '21px',
    xxxl: '33px',
  },
});

export default theme;
